import React from 'react';
import style from './MiniOrdersTable.module.css';
import { useWebsocketStore } from '../../../../../../../../stores/websocketStore/websocketProvider';
import { Body3, Body4 } from '../../../../../../../atomic/text/Text';
import { colors } from '../../../../../../../../colorVars';
import { CancelOrderButton } from '../../../../../../../atomic/buttons/cancelOrderButton/CancelOrderButton';
import { observer } from 'mobx-react-lite';
import { isOrderOpen } from '../../../../../../../../stores/websocketStore/utils/mungingUtils/orderStatusFilter';
import { MiniOrderTableRow } from './MiniOrderTableRow';

export const MiniOrdersTable = observer(({ tradePlanId }) => {
  const { tradePlanStore } = useWebsocketStore();
  const tradePlan = tradePlanStore.tradePlans[tradePlanId];
  const direction = tradePlan.goLong ? 'long' : 'short';
  const orders = tradePlanStore.ordersByTradePlanId[tradePlanId] ?? null;

  if (!orders)
    return (
      <div className={style.containerNoOrders}>
        <Body3 fontWeight={700} color={colors.lightGrey}>
          No orders to display.
        </Body3>
      </div>
    );

  const openOrderArray = Object.keys(orders).filter((orderId) =>
    isOrderOpen(orders[orderId].status, 'TRADIER')
  ).sort((a, b) =>  {
    if (direction === 'long') return Number(orders[a].price) - Number(orders[b].price); 
    else return Number(orders[b].price) - Number(orders[a].price); 
  });
  
  if (openOrderArray.length < 1)
    return (
      <div className={style.containerNoOrders}>
        <Body3 fontWeight={700} color={colors.lightGrey}>
          No orders to display.
        </Body3>
      </div>
    );

  return (
    <div className={style.container}>
      <table className={style.table}>
        <thead>
          <tr>
            <th>
              <div className={style.cancelButtonWrapper}>
                <CancelOrderButton  width={15} />
              </div>
            </th>
            <th>
              <Body4 fontWeight={700} color={colors.lightGrey}>
                Side
              </Body4>
            </th>
            <th>
              <Body4 fontWeight={700} color={colors.lightGrey}>
                Qty.
              </Body4>
            </th>
            <th>
              <Body4 fontWeight={700} color={colors.lightGrey}>
                Price
              </Body4>
            </th>
          </tr>
        </thead>
        <tbody className={style.tbody}>
          {openOrderArray.map((orderId) => (
            <MiniOrderTableRow orderId={orderId} key={orderId} />
          ))}
        </tbody>
      </table>
    </div>
  );
});
